// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1wAXq","error":"Textarea_error__2rWZV","readonly":"Textarea_readonly__3Jog-","disabled":"Textarea_disabled__2edcP"};